/* eslint-disable no-sparse-arrays */

/**
 * @param {*} value1
 * @param {*} value2
 *
 * @returns {*} one of the values
 */
export var combineStyle = function combineStyle(value1, value2) {
  if (value1 !== undefined || value2 !== undefined) {
    return value1 !== undefined ? value1 : value2;
  }

  return undefined;
};
/**
 * @param {*} flex
 * @param {*} flexGrow
 * @param {*} flexShrink
 * @param {*} flexBasis
 *
 * @returns {*} A normalized combination of the flex shorthand
 */

export var createFlexStyle = function createFlexStyle(flex, flexGrow, flexShrink, flexBasis) {
  if (flex) {
    return [, flex];
  }

  if (flexGrow !== undefined || flexShrink !== undefined || flexBasis !== undefined) {
    return [, (flexGrow !== undefined ? flexGrow : 0) + " " + (flexShrink !== undefined ? flexShrink : 1) + " " + (flexBasis !== undefined ? flexBasis : 'auto')];
  }

  return [undefined, undefined];
};